import { render, staticRenderFns } from "./home_5.vue?vue&type=template&id=35233904&scoped=true"
import script from "./home_5.vue?vue&type=script&lang=js"
export * from "./home_5.vue?vue&type=script&lang=js"
import style0 from "./home_5.vue?vue&type=style&index=0&id=35233904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35233904",
  null
  
)

export default component.exports